// extracted by mini-css-extract-plugin
export default {"content":"style_content__zSU8k","rightBlock":"style_rightBlock__YcUK9"};